import { useState } from 'react';

export const useModal = (value = false) => {
  const [open, setOpen] = useState(value);

  const handleAction = (callback?: any) => {
    setOpen(current => !current);
    typeof callback === 'function' && callback();
  };

  return [open, handleAction] as const;
};
